module.exports = "<div class=\"pg-grouper pg-column-dragtarget\"> <span class=pg-grouper-placeholder>Drag columns here to group.</span> </div>";